import { render, staticRenderFns } from "./VeJwJxrwRecycleBin.vue?vue&type=template&id=409baec4"
import script from "./VeJwJxrwRecycleBin.vue?vue&type=script&lang=js"
export * from "./VeJwJxrwRecycleBin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports